import React, { FC, useEffect, useState, useRef, useMemo } from 'react';
import Styles from 'components/chatSideBar/chatParticipants/ChatParticipants.module.scss';
import superHostKey from 'assets/images/superhost_user_key.png';
import locationIcon from 'assets/svg/location.svg';
import { IMAGE_URL } from 'store/services/URL';
import { getDistance } from 'helpers/utils';
import { useGetMessages, getRoomLocation } from 'store/services/firebase-broadcast';
import { updateRoomStatus } from 'store/services/firebase-broadcast';
import { ref, onValue } from 'firebase/database';
import { db } from 'utils/firebase-config';

import moment from 'moment';
import { isArray } from 'lodash';
interface ChatParticipantsProps {
  isSuperHost?: boolean;
  offLineImageCss?: boolean;
  itemIndex: boolean;
  handleChangeIndex: Function;
  id: number;
  item: any;
  activateRoom?: any;
  setActiveRoom?: any;
  callBack?: any;
  selected?: any;
}

const ChatParticipants: FC<ChatParticipantsProps> = (props: ChatParticipantsProps) => {
  const { isSuperHost, offLineImageCss, itemIndex, handleChangeIndex, item,callBack, activateRoom, setActiveRoom, selected} = props;
  
  const [avatar, setAvatar] = useState('');
  const [name, setName] = useState('');
  // const [activateRoom, setActiveRoom] = useState<any>(null);
  const [hover, setHover] = useState(item?.pin ?? false);
  const user = JSON.parse(localStorage.getItem('user') as string);
  const [chatItem, setChatItem] = useState<any>(0)
  const [hasPendingRequests, setHasPendingRequests] = useState(false);
  
  // Get location data from Firebase
  const locationInfo = getRoomLocation(item);
  const getAdmin = () => {
    const host = item.host;
    if (host && host.profile && host.name) {
      setAvatar(host.profile);
      setName(host.name);
    }
  };

  // OPTIMIZED: Load only message count for unread notifications
  const { chat } = useGetMessages(item?.pk);
  const [unreadMessage, setUnreadMessage] = useState(0);
  

  
  // Real-time room data listener to get updated lastSeenMessage
  const [liveRoomData, setLiveRoomData] = useState(item);
  
  useEffect(() => {
    if (!item?.pk) return;
    
    const roomRef = ref(db, `rooms/${item.pk}`);
    const unsubscribe = onValue(roomRef, (snapshot) => {
      if (snapshot.exists()) {
        const updatedRoomData = snapshot.val();
        setLiveRoomData(updatedRoomData);
      }
    });
    
    return () => unsubscribe();
  }, [item?.pk]);

  // Unread count logic using live room data
  useEffect(() => {
    // If room is selected, immediately set unread count to 0
    if (item?.pk === selected?.pk) {
      setUnreadMessage(0);
      return;
    }
    
    // If room is not selected, calculate unread count
    if (chat?.length > 0) {
      // Get the last seen message ID for current user
      // Since room is not selected, use liveRoomData (Firebase)
      let lastSeenMessageId: any;
      
      if (liveRoomData?.host?.pk === user?.pk) {
        lastSeenMessageId = liveRoomData?.host?.lastSeenMessage;
      } else if (isArray(liveRoomData?.participants)) {
        const meUser = liveRoomData?.participants?.find((p: any) => p?.pk === user?.pk);
        if (meUser) {
          lastSeenMessageId = meUser.lastSeenMessage;
        }
      }
      
      
      // Count unread messages (messages after the last seen message)
      if (lastSeenMessageId) {
        // Find the index of the last seen message
        const lastSeenIndex = chat.findIndex((message: any) => message.id === lastSeenMessageId);

        if (lastSeenIndex !== -1) {
          // Count messages AFTER the last seen message
          let count = chat.length - (lastSeenIndex + 1);
          setUnreadMessage(count);
        } else {
          // If lastSeenMessageId not found
          setUnreadMessage(0);
        }
      } else {
        // If no lastSeenMessageId
        setUnreadMessage(0);
      }
    } else {
      // No chat messages
      setUnreadMessage(0);
    }
  }, [chat, item?.pk, selected?.pk, liveRoomData?.host?.lastSeenMessage, liveRoomData?.participants, user?.pk]);

  React.useEffect(() => {
    getAdmin();
  }, []);

  // Check for pending join requests (only for rooms where current user is the host)
  useEffect(() => {
    if (!item?.pk || item?.host?.pk !== user?.pk) {
      setHasPendingRequests(false);
      return;
    }
    
    // Only check for pending requests if current user is the host
    const requestsRef = ref(db, `requests/${item.pk}/requests`);
    const unsubscribe = onValue(requestsRef, (snapshot) => {
      if (snapshot.exists()) {
        const requests = snapshot.val();
        const requestCount = Object.keys(requests).length;
        setHasPendingRequests(requestCount > 0);
      } else {
        setHasPendingRequests(false);
      }
    });
    
    return () => unsubscribe();
  }, [item?.pk, item?.host?.pk, user?.pk]);

  if (!item || !item.pk) {
    console.warn('Invalid item in ChatParticipants:', item);
    return null;
  }

  const activeRoomFun = async (item: any) => { 
    //  setActiveRoom(item)
  }

  let participant;
  if (item?.participants?.length > 0) {
    participant = item?.participants.find((r: any) => r?.pk === user?.pk)
  }

  // const clickHandler = (item: any) => {
  //   let updateRoom = {
  //     room: item,
  //     pin: !hover,
  //     timeStamp: !hover ? moment().format(): ""
  //   };
  //   updateRoomStatus(updateRoom);
  //   setHover(!hover);
  // };
  return (
    <li>
      <div
        className={`${Styles.listingInner} ${
          itemIndex ? Styles.activeChat : ""
        }`}
        onKeyPress={() => handleChangeIndex(item)}
        onClick={() => (
          handleChangeIndex(item), activeRoomFun(item)//, clickHandler(item)//, callBack(item)
        )}
        tabIndex={0}
        role="button"
      >
        <div className={Styles.userImageWrapper}>
          <img
            src={`${IMAGE_URL}${item?.host?.profile ?? ""}`}
            alt="card img"
            className={`${Styles.userImage} ${
              offLineImageCss ? Styles.offlineUserImage : ""
            } ${
              hasPendingRequests ? Styles.pendingRequestsImage : ""
            }`}
          />
          {/* {isSuperHost && (
            <img
              src={superHostKey}
              alt="super host"
              className={Styles.superHostImg}
            />
          )} */}
        </div>
        <div className={Styles.userDetails}>
          <div className={Styles.userInner}>
            <h5>{item.topic}</h5>
            <p>
              {item?.host?.name ?? ""}
              &lsquo;s Room
            </p>
            {/* Location display - only show if not both Unknown */}
            {locationInfo.city !== "Unknown" && locationInfo.country !== "Unknown" && (
              <p className={Styles.locationText}>
                <img src={locationIcon} alt="location" className={Styles.locationIcon} />
                {[locationInfo.city, locationInfo.country].filter(Boolean).join(', ')}
              </p>
            )}
          </div>

          {
          // Only show unread count if user is in the room AND there are unread messages
          (item?.host?.pk === user?.pk || 
            (isArray(item?.participants) && item?.participants?.some((p: any) => p?.pk === user?.pk))) &&
          unreadMessage > 0
          ? (
            <div className={Styles.notifications}>
              <span className={`badge badge-pill ${Styles.badgeDanger}`}>
                {unreadMessage}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </li>
  );
};
export default ChatParticipants;
